import { Link, useCanGoBack, useRouter } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { useGetParentById } from '~entities/parent/api/get-parent-by-id';

import { ParentSavedPaymentMethodsPanel } from '~shared/components/parent-saved-payment-methods-panel';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';

export function ParentSavedPaymentMethodsPage({
  parentId,
}: {
  parentId: string;
}) {
  const router = useRouter();
  const canGoBack = useCanGoBack();
  const { data: parent } = useGetParentById(parentId);
  const parentLabel =
    parent?.email ??
    ([parent?.firstName, parent?.lastName].filter(Boolean).join(' ') ||
      parent?.name) ??
    'this parent';

  return (
    <div className='p-4 sm:p-6'>
      <Link
        className='mb-4 flex min-w-0 items-center gap-2'
        to='/family'
        search={{ parentId }}
        onClick={(e) => {
          if (canGoBack) {
            e.preventDefault();
            router.history.back();
          }
        }}
      >
        <CircleArrowLeft className='size-6 shrink-0' />
        <h2 className='min-w-0 text-lg font-semibold'>
          {canGoBack ? 'Back' : 'Back to family'}
        </h2>
      </Link>

      <Card className='w-full max-w-md'>
        <CardHeader>
          <CardTitle>Saved payment methods</CardTitle>
          <CardDescription>
            Payment methods on file for {parentLabel}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ParentSavedPaymentMethodsPanel
            parentId={parentId}
            parentEmail={parent?.email}
          />
        </CardContent>
      </Card>
    </div>
  );
}
